import { defineStore } from 'pinia'
import { fetchAddress } from '@/Shared/Helpers/geolocationHelper.js'

export let useJourneyStore = defineStore('journeyStore', {
  state: () => ({
    plannedDestination: null,
    currentAddress: null,
    showError: false,
  }),

  actions: {
    async setDestination(destination) {
      this.plannedDestination = destination
      try {
        this.currentAddress = await fetchAddress(destination)
      } catch (error) {
        this.showError = true
      }
    },
  },

  getters: {
    hasDestination: (state) => !!state.plannedDestination,

    //here we changing address to allow journey planner search
    formattedDestination: (state) => {
      if (!state.currentAddress) return { label: 'Unknown Location', id: null, type: 'place' }
      return {
        label: state.currentAddress.formatted_address,
        id: state.currentAddress.place_id,
        type: 'place',
      }
    },
  },
})
